import { render, staticRenderFns } from "./saveInterviewQuestion.vue?vue&type=template&id=8971d91a&"
import script from "./saveInterviewQuestion.vue?vue&type=script&lang=js&"
export * from "./saveInterviewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./saveInterviewQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports